<template>
  <div
    v-if="isLoadingMap[item.pollId] && !display"
    class="playlist-layer playlist-item flex items-center"
    :class="{ active: (isCurrentLayout || isCurrentSampleLayout)}"
  >
    <div class="playlist-layer__skeleton" />

    <div class="layer-info">
      <button
        class="tb-btn tb-btn-text sm medium-em ml-1"
        title="Remove item from playlist"
        @click.stop.prevent="removeItem"
      >
        <i class="fas fa-minus-circle"></i>
      </button>
    </div>
  </div>

  <div
    v-else-if="display"
    class="playlist-layer playlist-item poll"
    :class="{ editing: isEditing }"
    :data-test="`poll:${display.displayId}`"
    @click="onClickTimelineItem"
  >
    <div class="layer-info">

      <button
        class="drag-handle tb-btn tb-btn-link sm low-em"
        title="Rearrange"
      >
        <span class="fas fa-grip-vertical" />
      </button>

      <div class="layer-title flex-grow ml-2">
        <img
          v-if="display?.previewUrl"
          class="layer-preview mr-2 aspect-[16/9] block object-cover bg-[#d9d9d9]"
          :src="display?.previewUrl"
          :alt="item.title"
        >

        <div class="flex-grow no-wrap--ellipsis">
          <div class="title-text">
            <span v-if="display.displayType === 'poll'" class="fak fa-hand-point-click mr-1 color-highlight-blue text-[13px]" />
            {{ item.title }}
          </div>
          <div class="description-text">{{ poll.title }}</div>
        </div>
      </div>

      <div class="layer-description capitalize ml-1">
        <duration
          v-model:duration="item.displayTime"
          class="ml-1"
        />
      </div>

      <preview-live-switch :item="item"></preview-live-switch>

      <dropdown position="left" class="more-actions ml-1">
        <template #trigger>
          <button class="tb-btn tb-btn-text sm medium-em" title="More actions">
            <i class="fas fa-ellipsis-v"></i>
          </button>
        </template>

        <template #dropdown-body>
          <button
            class="dropdown-list-item"
            @click="duplicateItem"
          >
            <span class="dropdown-list-item-label">
              Duplicate in Playlist
            </span>
          </button>

          <button
            v-if="canDuplicateInGroup"
            class="dropdown-list-item"
            @click="duplicateItemInGroup"
          >
            <span class="dropdown-list-item-label">
              Duplicate in Group
            </span>
          </button>

          <button
            v-if="canMergeUp"
            class="dropdown-list-item"
            @click="mergeUp"
            title="Merge with above item in the playlist"
          >
            <span class="dropdown-list-item-label">Merge Up</span>
          </button>

          <button
            v-if="canMergeDown"
            class="dropdown-list-item"
            @click="mergeDown"
            title="Merge with below item in the playlist"
          >
            <span class="dropdown-list-item-label">Merge Down</span>
          </button>

          <hr>

          <button
            class="dropdown-list-item"
            @click="removeItem"
          >
            <span class="dropdown-list-item-label warning">
              Remove
            </span>
          </button>
        </template>
      </dropdown>
    </div>
  </div>

  <div
    v-else
    class="playlist-layer playlist-item deleted"
    :class="{ active: (isCurrentLayout || isCurrentSampleLayout)}"
  >
    <div class="layer-info">
      <div class="deleted-message">This asset has been deleted, or failed to load.</div>

      <button
        class="tb-btn tb-btn-text sm medium-em ml-1"
        title="Remove item from playlist"
        @click.stop.prevent="removeItem"
      >
        <i class="fas fa-minus-circle"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TimelineMixins from '@/js/mixins/timeline-mixins';
import PreviewLiveSwitch from '../PreviewLiveSwitch.vue';
import duration from './duration-input/DurationInput.vue';

export default {
  name: 'TimelinePollComponent',
  mixins: [TimelineMixins],
  props: ['item'],

  components: {
    PreviewLiveSwitch,
    duration,
  },

  data() {
    return {
      pollsError: false,
    };
  },

  computed: {
    ...mapState('polls', [
      'lookupTable',
      'isLoadingMap',
    ]),

    poll() {
      return this.item && this.lookupTable[this.item.pollId];
    },

    display() {
      return this.poll?.displays?.find(display => display.displayId === this.item.displayId);
    },
  },
};
</script>
